export default "__VITE_ASSET__4c1347da__"